import { ManageVehicleDriverFormComponent } from "./manage-vehicle-driver-form/manage-vehicle-driver-form.component";
import { ViewManageVehicleDriverComponent } from "./view-manage-vehicle-driver/view-manage-vehicle-driver.component";

export const ManageVehicleDriverRouting = [
    
    { path: '', redirectTo: 'view-manage', pathMatch: 'full' },
    { path: 'view-manage/:vendorID', component: ViewManageVehicleDriverComponent },

    { path: 'manage-vehicle/:vendorID', component: ManageVehicleDriverFormComponent}, 
    { path: 'edit-manage-vehicle/:vendorID/:vehicleID', component: ManageVehicleDriverFormComponent},
    
];

export const ManageVehicleDriverRoutingBreadcrumbs = [
    // { name: 'View',path:'' },
    // { name: 'View',path:'/view-manage' },
    // { name: 'Edit', path: '/edit-manage-vehicle' },
    // { name: 'Assign', path: '/manage-vehicle' },

];